import { serialize } from 'object-to-formdata';
import moment from 'moment'

export const getObjectToFormData = (data) => {
  const formData = serialize(data);
  return formData;
}

export const numEnToBn = (str) => {
  str = str.toString()
  let bnNum = {
    0: '০',
    1: '১',
    2: '২',
    3: '৩',
    4: '৪',
    5: '৫',
    6: '৬',
    7: '৭',
    8: '৮',
    9: '৯'
  }
  for (let x in bnNum) {
    str = str.replace(new RegExp(x, 'g'), bnNum[x])
  }
  return str
}

export const objectToFormData = (obj) => {
  let formData = new FormData();
  Object.keys(obj).forEach(key => formData.append(key, obj[key]));
  return formData;
};

export const percentCompleted = (progressEvent) => {
  return Math.round((progressEvent.loaded * 100) / progressEvent.total)
}

export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
};

export const getLocalAuthData = () => {
  return JSON.parse(localStorage.getItem('userToken'));
}
export const getLocalAuthToken = () => {
  return JSON.parse(localStorage.getItem('authData'));
}

export const urlPramsToObj = (history) => {
  const search = history.location.search.substring(1);
  return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export const objToUrlPrams = (obj) => {
  const str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const twoDecimalPlace = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
}

export const getDate = (date) => {
  return moment(date).utcOffset('+0600')
}

export const getFormattedDate = (date, format) => {
  return date ? moment(date).utcOffset('+0600').format(format) : '';
}

export const refreshPage = (url, callback) => {
  setTimeout(() => {
    callback()
    window.location.replace(url)
  }, 1000)
}

export const replaceUnderscoreWithSpaceOfStr = (str) => str.toUpperCase().replace(/_/g, " ")
